import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {AUTH_SLICE} from 'store/slices/auth-slice/auth-slice-constants';

const selectAuthSliceState = (state: TAppState) => state[AUTH_SLICE];

export const selectIsAuthenticated = createSelector(
    selectAuthSliceState,
    ({isAuthenticated}) => isAuthenticated,
);

export const selectAuthError = createSelector(
    selectAuthSliceState,
    ({error}) => error,
);

export const selectAuthErrorUser = createSelector(
    selectAuthSliceState,
    ({userName}) => userName,
);

export const selectAuthPasswordExpired = createSelector(
    selectAuthSliceState,
    ({isPasswordExpired}) => isPasswordExpired,
);

export const selectAuthPasswordSuccessfullyChanged = createSelector(
    selectAuthSliceState,
    ({isPasswordSuccessfullyChanged}) => isPasswordSuccessfullyChanged,
);

export const selectUserInfo = createSelector(
    selectAuthSliceState,
    ({userInfo}) => userInfo,
);

export const selectUserId = createSelector(
    selectAuthSliceState,
    ({userInfo}) => userInfo?.userId,
);

export const selectUseTwoFAVerificationFlag = createSelector(
    selectAuthSliceState,
    ({useTwoFAVerificationFlag}) => useTwoFAVerificationFlag,
);

export const selectTwoFactorAuthTypeCode = createSelector(
    selectAuthSliceState,
    ({twoFactorAuthTypeCode}) => twoFactorAuthTypeCode,
);

export const selectAuthProfile = createSelector(
    selectAuthSliceState,
    ({profile}) => profile,
);

export const selectMicroserviceToken = createSelector(
    selectAuthSliceState,
    ({microserviceToken}) => microserviceToken,
);

export const selectTwoFaCodeValidityTimeInSeconds = createSelector(
    selectAuthSliceState,
    ({twoFaCodeValidity}) => twoFaCodeValidity,
);

export const authSelectors = {
    selectAuthSliceState,

    selectIsAuthenticated,
    selectAuthError,
    selectAuthErrorUser,
    selectAuthPasswordSuccessfullyChanged,
    selectUserInfo,
    selectUserId,
    selectUseTwoFAVerificationFlag,
    selectAuthProfile,
    selectMicroserviceToken,
    selectTwoFaCodeValidityTimeInSeconds,
};
